export const DEMO_USER = {
  _id: "demo-user-001",
  name: "Demo Player",
  diamond: 50000,
  image: null,
};

export const DEMO_GAME_COIN = [100, 200, 300, 400, 500];

const INITIAL_HISTORIES = [3, 1, 5, 7, 2, 8, 4, 6, 3, 5];

const DEMO_LEADERBOARD = [
  { userId: "u1", name: "GoldenEagle", image: null, totalDiamonds: 48200 },
  { userId: "u2", name: "LuckyStrike99", image: null, totalDiamonds: 37500 },
  { userId: "u3", name: "DiamondKing", image: null, totalDiamonds: 29100 },
  { userId: "u4", name: "NightOwl", image: null, totalDiamonds: 21800 },
  { userId: "u5", name: "SpinMaster", image: null, totalDiamonds: 18400 },
  { userId: "u6", name: "WheelWizard", image: null, totalDiamonds: 15300 },
  { userId: "u7", name: "JackpotJill", image: null, totalDiamonds: 12700 },
  { userId: "u8", name: "CoinRush", image: null, totalDiamonds: 9900 },
  { userId: "u9", name: "FortuneFox", image: null, totalDiamonds: 7600 },
  { userId: "u10", name: "StarPlayer", image: null, totalDiamonds: 5200 },
];

const DEMO_HISTORY_RECORDS = [
  { Bit: 200, selectedFrame: 3, winnerNumber: 3, isWinner: true, winnerNumberTimes: 10, createdAt: new Date(Date.now() - 60000).toISOString() },
  { Bit: 100, selectedFrame: 1, winnerNumber: 5, isWinner: false, winnerNumberTimes: null, createdAt: new Date(Date.now() - 120000).toISOString() },
  { Bit: 300, selectedFrame: 7, winnerNumber: 7, isWinner: true, winnerNumberTimes: 5, createdAt: new Date(Date.now() - 180000).toISOString() },
  { Bit: 100, selectedFrame: 2, winnerNumber: 4, isWinner: false, winnerNumberTimes: null, createdAt: new Date(Date.now() - 240000).toISOString() },
  { Bit: 500, selectedFrame: 6, winnerNumber: 6, isWinner: true, winnerNumberTimes: 45, createdAt: new Date(Date.now() - 300000).toISOString() },
];

export function createDemoSocket() {
  const listeners = {};
  let diamond = DEMO_USER.diamond;
  let time = 25;
  let roundNo = 42;
  let winnerFrame = 0;
  let recentHistories = [...INITIAL_HISTORIES];
  let intervalRef = null;

  const trigger = (event, data) => {
    (listeners[event] || []).forEach((cb) => cb(data));
  };

  const fakeSocket = {
    connected: true,

    on(event, cb) {
      if (!listeners[event]) listeners[event] = [];
      listeners[event].push(cb);
      return this;
    },

    off(event, cb) {
      if (cb) {
        listeners[event] = (listeners[event] || []).filter((fn) => fn !== cb);
      } else {
        delete listeners[event];
      }
      return this;
    },

    emit(event, data) {
      if (event === "startGame") {
        setTimeout(() => {
          trigger("start", { ...DEMO_USER, diamond });
          trigger("gameRound", roundNo);
          trigger("todayProfit", 1250);
          trigger("lastHistories", recentHistories);
          trigger("game", { UsersBits: [] });
        }, 300);
      }
      if (event === "bit") {
        diamond = Math.max(0, diamond - (data?.Bit || 0));
        setTimeout(() => trigger("user", { ...DEMO_USER, diamond }), 100);
      }
      if (event === "user") {
        setTimeout(() => trigger("user", { ...DEMO_USER, diamond }), 100);
      }
      if (event === "historyRecord") {
        setTimeout(() => trigger("historyRecord", DEMO_HISTORY_RECORDS), 100);
      }
      if (event === "leaderboard") {
        setTimeout(() => trigger("leaderboard", DEMO_LEADERBOARD), 100);
      }
      return this;
    },

    disconnect() {
      if (intervalRef) clearInterval(intervalRef);
    },
  };

  intervalRef = setInterval(() => {
    trigger("time", time);

    if (time === 1) {
      winnerFrame = Math.floor(Math.random() * 8) + 1;
    }

    if (time === -12) {
      trigger("randomWinnerNumber", winnerFrame);
      trigger("winnerUserArray", {
        winnerNumber: winnerFrame,
        winnerUserArray: [
          { _id: "w1", name: "Alice", image: null, userWinCoin: 1500, number: 1 },
          { _id: "w2", name: "Bob", image: null, userWinCoin: 800, number: 2 },
          { _id: "w3", name: "Carol", image: null, userWinCoin: 300, number: 3 },
        ],
      });
      recentHistories = [winnerFrame, ...recentHistories.slice(0, 9)];
    }

    if (time === 25) {
      roundNo++;
      trigger("gameRound", roundNo);
      trigger("game", { UsersBits: [] });
      trigger("lastHistories", recentHistories);
      trigger("todayProfit", DEMO_USER.diamond - diamond > 0 ? 0 : DEMO_USER.diamond - diamond);
    }

    time--;
    if (time < -13) time = 25;
  }, 1000);

  return fakeSocket;
}
